import { Palmtree } from "lucide-react";

const ITEMS = [
  "Bespoke Goa Holidays",
  "Romantic Sunset Cruises",
  "Candlelight Beach Dinners",
  "North & South Goa Sightseeing",
  "Luxury Beachfront Resorts",
  "VIP Nightlife Reservations",
  "Private AC Transfers",
  "24x7 Local Assistance",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-gold/15 bg-navy-deep py-4 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee gap-0">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-6 pr-6 whitespace-nowrap">
            <span className="font-cinzel text-xs sm:text-sm tracking-[0.3em] uppercase text-gold/80">{item}</span>
            <Palmtree className="w-3.5 h-3.5 text-gold/40" />
          </span>
        ))}
      </div>
    </div>
  );
}
